const ar_booking = {
  "booking.hero.badge": "حجز موعد",
  "booking.hero.heading": "احجز جلسة تقييمك",
  "booking.hero.desc": "4 خطوات بسيطة لحجز جلسة تقييم عميق مع أحد استشاريينا المتخصصين",

  "booking.progress.service": "الخدمة",
  "booking.progress.doctor": "الطبيب",
  "booking.progress.datetime": "الموعد",
  "booking.progress.info": "بياناتك",
  "booking.progress.step_indicator": "الخطوة {{current}} من {{total}}",

  "booking.step1.heading": "اختر الخدمة",
  "booking.step1.desc": "ابدأ باختيار الخدمة التي تحتاجها",
  "booking.step1.filter_all": "الكل",
  "booking.step1.selected": "الخدمة المختارة",
  "booking.step1.continue": "متابعة — اختيار الطبيب",
  "booking.step1.from": "من",
  "booking.step1.clear_all": "مسح الكل",

  "booking.step2.heading": "اختر الطبيب",
  "booking.step2.desc": "اختر الاستشاري المناسب لحالتك",
  "booking.step2.search": "ابحث بالاسم أو التخصص...",
  "booking.step2.visit_type": "نوع الزيارة",
  "booking.step2.first_visit": "زيارة أولى",
  "booking.step2.followup": "متابعة",
  "booking.step2.consultation": "استشارة",
  "booking.step2.first_visit_desc": "للمرضى الجدد",
  "booking.step2.followup_desc": "للمرضى الحاليين",
  "booking.step2.consultation_desc": "رأي طبي متخصص",
  "booking.step2.selected_services": "الخدمات المختارة:",
  "booking.step2.change": "تغيير",
  "booking.step2.choose_docs": "اختر أطباء الخدمات المحددة",
  "booking.step2.choose_docs_desc": "يرجى تحديد الطبيب المفضل لكل خدمة طبية",
  "booking.step2.choose_visit_type": "نوع الزيارة",
  "booking.step2.choose_doc_for_svc": "اختر الطبيب المعالج لهذه الخدمة:",
  "booking.step2.specialist_first": "متخصصون في خدمتك",
  "booking.step2.other_doctors": "استشاريون آخرون",
  "booking.step2.continue": "متابعة — اختيار الموعد",
"booking.confirm.service_price":"سعر الخدمة",
  "booking.step3.heading": "اختر الموعد",
  "booking.step3.desc": "اختر التاريخ والوقت المناسبين",
  "booking.step3.morning": "الصباح",
  "booking.step3.afternoon": "الظهيرة",
  "booking.step3.evening": "المساء",
  "booking.step3.booked": "محجوز",
  "booking.step3.selected_slot": "الموعد المختار",
  "booking.step3.continue": "متابعة — بياناتك",
  "booking.step3.selected_doctors": "الأطباء المعالجون المختارون:",
  "booking.step3.this_week": "هذا الأسبوع",
  "booking.step3.next_week": "الأسبوع القادم",
  "booking.step3.week_num": "الأسبوع {{num}}",
  "booking.step3.available_time": "الوقت المتاح",
  "booking.step3.selected": "محدد",
  "booking.step3.select_date_prompt": "اختر تاريخاً لعرض المواعيد المتاحة",
  "booking.step3.slot_selected_badge": "تم اختيار الموعد",

  "booking.step4.heading": "بياناتك الشخصية",
  "booking.step4.summary": "ملخص الحجز",
  "booking.step4.name": "الاسم الكامل",
  "booking.step4.phone": "رقم الجوال",
  "booking.step4.email": "البريد الإلكتروني",
  "booking.step4.age": "العمر",
  "booking.step4.gender": "الجنس",
  "booking.step4.male": "ذكر",
  "booking.step4.female": "أنثى",
  "booking.step4.notes": "ملاحظات إضافية",
  "booking.step4.notes_placeholder": "أي معلومات إضافية تود مشاركتها مع الطبيب...",
  "booking.step4.confirm": "تأكيد الحجز",
  "booking.step4.terms": "بالمتابعة أوافق على سياسة الخصوصية وشروط الاستخدام",
  "booking.step4.subheading": "خطوة أخيرة لإتمام الحجز",
  "booking.step4.undefined": "غير محدد",
  "booking.step4.edit_slot": "تعديل الموعد",
  "booking.step4.name_placeholder": "أدخل اسمك الكامل",
  "booking.step4.age_placeholder": "بالسنوات",
  "booking.step4.select_placeholder": "اختر...",
  "booking.step4.optional": "(اختياري)",
  "booking.step4.max_chars": "الحد الأقصى 500 حرف",
  "booking.step4.agree_prefix": "أوافق على ",
  "booking.step4.privacy_policy": "سياسة الخصوصية",
  "booking.step4.agree_and": " و ",
  "booking.step4.terms_of_use": "شروط الاستخدام",
  "booking.step4.submit_error": "حدث خطأ أثناء الإرسال. يرجى المحاولة مرة أخرى.",
  "booking.step4.confirming": "جاري تأكيد الحجز...",

  "booking.confirmation.heading": "تم تأكيد حجزك!",
  "booking.confirmation.desc": "سيتواصل معك فريقنا خلال ساعة لتأكيد التفاصيل",
  "booking.confirmation.ref": "رقم الحجز",
  "booking.confirmation.home": "العودة للرئيسية",
  "booking.confirmation.another": "حجز موعد آخر",

  "booking.info.confirm_title": "تأكيد فوري",
  "booking.info.confirm_desc": "سيتصل بك فريقنا لتأكيد الموعد",
  "booking.info.secure_title": "بيانات آمنة",
  "booking.info.secure_desc": "معلوماتك محمية ومشفرة بالكامل",
  "booking.info.cancel_title": "إلغاء مجاني",
  "booking.info.cancel_desc": "يمكنك الإلغاء قبل 24 ساعة مجاناً",

  "booking.confirm.calendar_event": "موعد طبي في ذا مديكال أفينيو",
  "booking.confirm.doctors": "الأطباء",
  "booking.confirm.visit_type": "نوع الزيارة",
  "booking.confirm.package": "الباقة",
  "booking.confirm.support_phone": "للاستفسار: 011 234 5678",
  "booking.confirm.hello": "مرحباً {{name}}، تم استلام طلب حجزك بنجاح",
  "booking.confirm.details_title": "تفاصيل الموعد",
  "booking.confirm.location_val": "شارع الملك فهد، حي العليا، الرياض",
  "booking.confirm.date": "التاريخ",
  "booking.confirm.time": "الوقت",
  "booking.confirm.location": "الموقع",
  "booking.confirm.main_clinic": "العيادة الرئيسية",
  "booking.confirm.requested_services": "الخدمات المطلوبة:",
  "booking.confirm.selected_doctors": "الأطباء المعالجون المختاريين:",
  "booking.confirm.consultation_fees": "رسوم الاستشارة",
  "booking.confirm.total_fees": "إجمالي رسوم الاستشارة للأطباء:",
  "booking.confirm.selected_package": "الباقة المختارة",
  "booking.confirm.saved": "وفرت",
  "booking.confirm.expected_duration": "مدة الفحص المتوقعة:",
  "booking.confirm.prep_instructions": "تعليمات التحضير للفحص",
  "booking.confirm.whats_next": "ماذا يحدث بعد ذلك؟",
  "booking.confirm.timeline.1.title": "تأكيد هاتفي",
  "booking.confirm.timeline.1.desc": "سيتصل بك فريقنا خلال ساعات قليلة لتأكيد الموعد",
  "booking.confirm.timeline.2.title": "رسالة تذكير",
  "booking.confirm.timeline.2.desc": "ستصلك رسالة تذكير قبل موعدك بـ 24 ساعة",
  "booking.confirm.timeline.3.title": "الحضور للعيادة",
  "booking.confirm.timeline.3.desc": "احضر قبل موعدك بـ 15 دقيقة مع هويتك الشخصية",
  "booking.confirm.timeline.4.title": "استلام التقرير",
  "booking.confirm.timeline.4.desc": "ستحصل على تقريرك الطبي إلكترونياً في نفس اليوم",
  "booking.confirm.location_title": "موقع العيادة",
  "booking.confirm.clinic_name": "ذا مديكال أفينيو — منصة الطب الدقيق",
  "booking.confirm.clinic_address": "شارع الملك فهد، حي العليا، الرياض 12345",
  "booking.confirm.clinic_hours": "أوقات العمل: السبت - الخميس، 8 صباحاً - 10 مساءً",
  "booking.confirm.directions": "الاتجاهات",
  "booking.confirm.contact_us": "تواصل معنا",
  "booking.confirm.patient_info": "بيانات المريض",
  "booking.confirm.name_label": "الاسم",
  "booking.confirm.phone_label": "رقم الجوال",
  "booking.confirm.email_label": "البريد الإلكتروني",
  "booking.confirm.cancel_note": "يمكنك إلغاء أو تعديل موعدك مجاناً قبل 24 ساعة من الموعد المحدد. للإلغاء، تواصل معنا عبر واتساب أو اتصل على {{phone}} مع ذكر رقم الحجز {{ref}}.",
  "booking.confirm.confirmed_badge": "مؤكد",
  "booking.confirm.copied": "تم النسخ!",
  "booking.confirm.copy_num": "نسخ الرقم",
  "booking.confirm.shared": "تمت المشاركة!",
  "booking.confirm.share": "مشاركة",
  "booking.confirm.share_title": "تأكيد الحجز — ذا مديكال أفينيو",
  "booking.confirm.share_template": "تم تأكيد حجزي في ذا مديكال أفينيو\nرقم الحجز: {{ref}}\nالاسم: {{name}}",
  "booking.confirm.ref_card_note": "سيتواصل معك فريقنا على {{phone}} لتأكيد الموعد خلال ساعات قليلة. احتفظ برقم الحجز للمراجعة.",
  "booking.banner.preselected": "باقة محددة مسبقاً",
  "booking.banner.view_details": "عرض التفاصيل",
  "booking.banner.hide": "إخفاء",
  "booking.banner.more_features": "+{{count}} ميزة أخرى",
  "booking.banner.auto_added_note": "هذه الباقة ستُضاف لحجزك تلقائياً. يمكنك تغييرها في أي وقت.",
  "common.sar":"ر.س",
};

export default ar_booking;
